window.$ = window.jQuery

// Load front end styles
import './frontend.less'

// Vue library
window.Vue = require('vue')
Vue.config.productionTip = false

// Vee Validate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// Vue Select
Vue.component('v-select', vSelect)
import vSelect from 'vue-select'

import VModal from 'vue-js-modal'
Vue.use(VModal)

// Global functions
require('../../../chop/js/functions.js')
require('../../js/functions.js')

// Plugins
require('../../../chop/js/plugins/mobile_menu.js')

// Parent script file
require('../../../chop/js/script.js')

// Child script file
require('../../../chop-child/js/script.js')
require('../../../chop-child/js/plugins/slick/slick.min.js')

// MtcPostFilter assets
require('../../../../plugins/MtcPostFilter/assets/script.js')

// MtcBlockVideos assets
require('../../../../plugins/MtcBlockVideos/assets/script.js')

// MtcBlockVacancies assets
require('../../../../plugins/MtcBlockVacancies/assets/script.js')

// MtcBlockTextImageGrid assets
require('../../../../plugins/MtcBlockTextImageGrid/assets/script.js')

// Case Studies component
import CaseStudies from '../../../chop-child/js/components/case_studies.vue'
Vue.component('case-studies', CaseStudies)

// Products component
import Products from '../../../chop-child/js/components/products.vue'
Vue.component('products', Products)

/**
 * Webfonts Loader / typekit
 */
import WebFont from 'webfontloader'
WebFont.load({
    google: {
        families: ['Lexend:100,200,300,400,500,600,700,800,900', 'Lexend Deca:100,200,300,400,500,600,700,800,900']
    },
    active: () => {
        sessionStorage.fonts = true;
    }
})

window.addEventListener('DOMContentLoaded', function () {
    const site_wrappers = document.getElementsByClassName('siteWrapper');
    
    Array.from(site_wrappers).forEach(site_wrapper => {
        const script_tags = [...site_wrapper.getElementsByTagName('script')];
        const style_tags = [...site_wrapper.getElementsByTagName('style')];

        script_tags.concat(style_tags).forEach(tag => {
            document.body.append(tag);
        });
    });

    window.vue_environment = new Vue({  
        el: '.siteWrapper'
    });
})

